import couponSelectors from 'features/coupon/services/selectors';
import React, { useState } from 'react';
import BgDesktopCoupon from '../components/BgDesktopCoupon';
import VerifyOtpForm from './VerifyOtpForm';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { IResponseDataBody } from 'services/response';
import { ISubmitReceiveCouponResData, IVerifyOtpResData } from '../types';
import couponApis from '../services/apis';
import { setLoadingPage } from 'services/UI/sagas';
import { useAppDispatch } from 'store/hooks';
import { couponActions } from 'features/coupon/services/reducers';
import toast from 'utils/toast';

const CouponVerifyOtpPage: React.FC = () => {
  const { shop_id } = useParams();
  const location = useLocation();
  const couponReceiveDiscountSetting = couponSelectors.couponReceiveDiscountSetting();
  const { phoneNumber = '' } = (location.state as { phoneNumber: string }) || {};
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const otpPayload = couponSelectors.payloadResendOtp();
  const id = couponSelectors.refIdReceiveCoupon();
  
  const handleVerifyOTP = async (otp: string) => {
    setLoadingPage(true);
    try {
      const res: IResponseDataBody<IVerifyOtpResData> = await couponApis.verifyOTP(id || '', otp);
      if (res.data.data.verifyOtp) {
        dispatch(couponActions.setCouponReceive(res.data.data.coupon));
        navigate(`/store/${shop_id}/coupon-receive/success`);
      } else {
        setError(res.data.data.message);
      }
    } catch (error) {
      setError('Fail');
    } finally {
      setLoadingPage(false);
    }
  };

   const handleResend = async () => {
    setLoadingPage(true);
    try {
      const res: IResponseDataBody<ISubmitReceiveCouponResData> = await couponApis.getSubmitReceiveCoupon(
        otpPayload?.phone ?? '',
        otpPayload?.name ?? '',
        otpPayload?.dob,
        otpPayload?.email
      );

      if (res.data.data) {
        dispatch(couponActions.setRefIdReceiveCoupon(res.data.data.refId));
        if (res.data.data.verify) {
          toast.success('OTP resent successfully');
        } 
      }
    } catch (error) {
      toast.error('Failed to resend OTP');
    } finally {
      setLoadingPage(false);
    }
   };

  return (
    <BgDesktopCoupon urlImage={couponReceiveDiscountSetting?.urlImage}>
      <VerifyOtpForm phoneNumber={phoneNumber} onVerify={handleVerifyOTP} error={error} onResend={handleResend} />
    </BgDesktopCoupon>
  );
};

export default CouponVerifyOtpPage;
